import axios from "axios";
import i18n from "i18n";
import { getRequest, postRequest } from "./ApiRequest";

// ---- Portale pubblico delle cantine (nessun login: il token e' nel link) ----
// Client separato: non invia il login dell'amministratore e un errore 401 non ricarica la pagina.
const pub = axios.create({ baseURL: process.env.REACT_APP_BASE_URL, timeout: 120000 });
const unwrap = (p) => p.then((r) => r.data).catch((e) => Promise.reject(e?.response?.data || { message: i18n.t("producers:network.error") }));

const P = (token) => `producer/portal/${encodeURIComponent(token)}`;
export const GetPortalAPI = (token) => unwrap(pub.get(P(token)));
export const AcceptTermsAPI = (token) => unwrap(pub.post(`${P(token)}/terms`, {}));
export const ProposeWineChangeAPI = (token, wineId, payload) => unwrap(pub.patch(`${P(token)}/wines/${wineId}`, payload));
export const ProposeNewWineAPI = (token, payload) => unwrap(pub.post(`${P(token)}/wines`, payload));
export const UploadPortalImageAPI = (token, submissionId, slot, file) => {
  const form = new FormData();
  form.append("slot", slot);
  form.append("image", file);
  return unwrap(pub.post(`${P(token)}/submissions/${submissionId}/image`, form));
};
// Lista vini da file (PDF, Excel, CSV) o da link: prima l'anteprima, poi la conferma.
export const PreviewImportAPI = (token, { file, url }) => {
  if (file) {
    const form = new FormData();
    form.append("file", file);
    return unwrap(pub.post(`${P(token)}/import/preview`, form));
  }
  return unwrap(pub.post(`${P(token)}/import/preview`, { url }));
};
export const ConfirmImportAPI = (token, wines) => unwrap(pub.post(`${P(token)}/import/confirm`, { wines }));

// ---- Amministrazione ----
export const GetProducersAPI = (params) => getRequest(`admin/producers?${new URLSearchParams(params).toString()}`);
export const CreateProducerLinkAPI = (payload) => postRequest("admin/producers/link", payload);
export const GetSubmissionsAPI = (status = "pending", page = 1) => getRequest(`admin/producers/submissions?status=${status}&page=${page}`);
export const ApproveSubmissionAPI = (id) => postRequest(`admin/producers/submissions/${id}/approve`, {});
export const RejectSubmissionAPI = (id, note) => postRequest(`admin/producers/submissions/${id}/reject`, { note });
